module.exports = __webpack_public_path__ + "static/media/1.fb5617f6.JPG";